import React, { useState } from 'react';
import { Ship, MapPin, DollarSign, Calendar, Hash, ChevronLeft, ChevronRight, Factory, TrendingUp, Star, Phone, Mail, FileText } from 'lucide-react';
import BoatModal from './BoatModal';

const FactoryBoatsPage = () => {
  const [selectedBoat, setSelectedBoat] = useState(null);
  const [viewMode, setViewMode] = useState('grid'); // grid or list

  // Factory special inventory with real boats
  const factoryInventory = [
    {
      id: 'FAC001',
      model: 'Ri245',
      year: 2025,
      title: '2025 Centurion Ri245 - Buyback',
      price: 165000,
      msrp: 185000,
      wholesalePrice: 145000,
      status: 'Customer Buyback',
      color: 'Black Metal Flake / Gunmetal',
      engine: 'PCM ZZ6 6.0L',
      hours: 5,
      stockNumber: 'BB2025-245',
      location: 'Springville, UT',
      description: 'Customer buyback program boat. Like new condition with full factory warranty. Only 5 hours!',
      features: ['QuickSurf Pro', 'RAMFILL Ballast', 'Silent Stinger Wake Plate', 'Premium Audio Package', 'Bimini Top', 'Surf Pipe'],
      images: [
        'https://images.onlyinboards.com/Centurion/2025/Model-Images/Model-Features-Ri245-01.png',
        'https://images.onlyinboards.com/Centurion/2025/Model-Images/Model-Features-Ri245-02.png'
      ],
      buildSheetURL: 'https://www.centurionboats.com/documents/brochures/2025-centurion-brochure.pdf',
      savings: 20000,
      factoryWarranty: true,
      deliveryTime: 'Immediate'
    },
    {
      id: 'FAC002',
      model: 'Ri230',
      year: 2024,
      title: '2024 Centurion Ri230 - World\'s Demo',
      price: 145000,
      msrp: 165000,
      wholesalePrice: 128000,
      status: 'Championship Demo',
      color: 'Black / Silver',
      engine: 'PCM ZZ6 6.0L',
      hours: 20,
      stockNumber: 'WD2024-230',
      location: 'Springville, UT',
      description: 'Used at the 2024 World Wake Surfing Championship. Professionally maintained, premium upgrades.',
      features: ['QuickSurf Pro', 'RAMFILL Ballast', 'World Championship Setup', 'Tower Speakers', 'Premium Interior', 'Custom Graphics'],
      images: [
        'https://images.onlyinboards.com/Centurion/2024/Model-Images/Model-Features-Ri230-01.png',
        'https://images.onlyinboards.com/Centurion/2024/Model-Images/Model-Features-Ri230-02.png'
      ],
      buildSheetURL: 'https://www.centurionboats.com/documents/brochures/2024-ri230-specs.pdf',
      savings: 20000,
      factoryWarranty: true,
      deliveryTime: 'Immediate'
    },
    {
      id: 'FAC003',
      model: 'Fi23',
      year: 2025,
      title: '2025 Centurion Fi23 - Pro Team Edition',
      price: 135000,
      msrp: 155000,
      wholesalePrice: 119000,
      status: 'Pro Team Config',
      color: 'Custom Pro Team Graphics',
      engine: 'PCM ZZ6 6.0L',
      hours: 0,
      stockNumber: 'PT2025-F23',
      location: 'Springville, UT',
      description: 'Special pro team configuration with upgraded sound system, custom wrap, and performance package.',
      features: ['QuickSurf Pro', 'RAMFILL Ballast', 'Pro Audio System', 'Custom Wrap', 'RGB Lighting', 'Performance Package'],
      images: [
        'https://images.onlyinboards.com/Centurion/2025/Model-Images/Model-Features-Fi23-01.png',
        'https://images.onlyinboards.com/Centurion/2025/Model-Images/Model-Features-Fi23-02.png'
      ],
      savings: 20000,
      factoryWarranty: true,
      deliveryTime: 'Immediate'
    },
    {
      id: 'FAC004',
      model: 'Ri257',
      year: 2025,
      title: '2025 Centurion Ri257 - Dealer Demo',
      price: 195000,
      msrp: 225000,
      wholesalePrice: 172000,
      status: 'Dealer Demo',
      color: 'Metallic Blue / Silver',
      engine: 'PCM ZZ8 6.2L Supercharged',
      hours: 8,
      stockNumber: 'DD2025-257',
      location: 'Springville, UT',
      description: 'Dealer demo with all options. Ramfill ballast, upgraded audio, dual screen helm.',
      features: ['QuickSurf Pro', 'RAMFILL Ballast', 'Dual Screen Helm', 'Premium Audio', 'Heated Seats', 'All Options'],
      images: [
        'https://images.onlyinboards.com/Centurion/2025/Model-Images/Model-Features-Ri257-01.png',
        'https://images.onlyinboards.com/Centurion/2025/Model-Images/Model-Features-Ri257-02.png'
      ],
      buildSheetURL: 'https://www.centurionboats.com/documents/brochures/2025-ri257-flagship.pdf',
      savings: 30000,
      factoryWarranty: true,
      deliveryTime: 'Immediate'
    },
    {
      id: 'FAC005',
      model: 'Vi24',
      year: 2024,
      title: '2024 Centurion Vi24 - Show Special',
      price: 125000,
      msrp: 145000,
      wholesalePrice: 110000,
      status: 'Boat Show Display',
      color: 'Pearl White / Blue',
      engine: 'PCM ZZ6 6.0L',
      hours: 3,
      stockNumber: 'SS2024-V24',
      location: 'Springville, UT',
      description: 'Boat show special. Display model with premium interior package and custom graphics.',
      features: ['QuickSurf Pro', 'RAMFILL Ballast', 'Premium Interior', 'Custom Graphics', 'Show Package', 'Tower Speakers'],
      images: [
        'https://images.onlyinboards.com/Centurion/2024/Model-Images/Model-Features-Vi24-01.png',
        'https://images.onlyinboards.com/Centurion/2024/Model-Images/Model-Features-Vi24-02.png'
      ],
      savings: 20000,
      factoryWarranty: true,
      deliveryTime: 'Immediate'
    },
    {
      id: 'FAC006',
      model: 'Ri217',
      year: 2025,
      title: '2025 Centurion Ri217 - Factory Special',
      price: 115000,
      msrp: 135000,
      wholesalePrice: 102000,
      status: 'Factory Special',
      color: 'Gunmetal / Black',
      engine: 'PCM ZZ6 6.0L',
      hours: 0,
      stockNumber: 'FS2025-217',
      location: 'Springville, UT',
      description: 'Limited factory special pricing. Quicksurf system, premium tower, and teak platform.',
      features: ['QuickSurf Pro', 'RAMFILL Ballast', 'Premium Tower', 'Teak Platform', 'Tower Speakers', 'Depth Finder'],
      images: [
        'https://images.onlyinboards.com/Centurion/2025/Model-Images/Model-Features-Ri217-01.png',
        'https://images.onlyinboards.com/Centurion/2025/Model-Images/Model-Features-Ri217-02.png'
      ],
      savings: 20000,
      factoryWarranty: true,
      deliveryTime: 'Immediate'
    }
  ];

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  return (
    <div className="factory-inventory-page">
      <div className="page-header factory-header">
        <Factory size={40} />
        <h1>Factory Direct Inventory</h1>
        <p>Exclusive factory-direct boats available for immediate dealer purchase</p>
      </div>

      {/* Factory Benefits Banner */}
      <div className="factory-benefits">
        <div className="benefit-item">
          <TrendingUp size={24} />
          <div>
            <strong>Better Margins</strong>
            <span>Up to $30k savings</span>
          </div>
        </div>
        <div className="benefit-item">
          <Ship size={24} />
          <div>
            <strong>Immediate Delivery</strong>
            <span>Most units ship within days</span>
          </div>
        </div>
        <div className="benefit-item">
          <Star size={24} />
          <div>
            <strong>Factory Warranty</strong>
            <span>Full manufacturer coverage</span>
          </div>
        </div>
        <div className="benefit-item">
          <DollarSign size={24} />
          <div>
            <strong>Special Pricing</strong>
            <span>Dealer-only rates</span>
          </div>
        </div>
      </div>

      {/* View Toggle */}
      <div className="view-controls">
        <span className="results-count">{factoryInventory.length} boats available</span>
        <div className="view-toggle">
          <button 
            className={viewMode === 'grid' ? 'active' : ''}
            onClick={() => setViewMode('grid')}
          >
            Grid View
          </button>
          <button 
            className={viewMode === 'list' ? 'active' : ''}
            onClick={() => setViewMode('list')}
          >
            List View
          </button>
        </div>
      </div>

      {/* Inventory Display */}
      <div className={`factory-inventory-${viewMode}`}>
        {factoryInventory.map(boat => (
          <div key={boat.id} className="factory-boat-card">
            {/* Status Badge */}
            <div className="status-badge" data-status={boat.status.toLowerCase().replace(/\s+/g, '-')}>
              {boat.status}
            </div>

            {/* Savings Badge */}
            {boat.savings > 0 && (
              <div className="savings-badge">
                Save {formatPrice(boat.savings)}
              </div>
            )}

            <div className="boat-image-section">
              <Ship size={60} className="boat-placeholder" />
              {boat.factoryWarranty && (
                <div className="warranty-badge">
                  <Star size={12} />
                  Factory Warranty
                </div>
              )}
            </div>

            <div className="boat-info-section">
              <h3>{boat.title}</h3>
              <div className="boat-specs">
                <span className="spec-item">
                  <Calendar size={14} />
                  {boat.year}
                </span>
                <span className="spec-item">
                  <Ship size={14} />
                  {boat.model}
                </span>
                <span className="spec-item">
                  <Hash size={14} />
                  {boat.stockNumber}
                </span>
                <span className="spec-item">
                  <MapPin size={14} />
                  {boat.location}
                </span>
              </div>

              <p className="boat-description">{boat.description}</p>

              <div className="boat-details">
                <div className="detail-item">
                  <strong>Color:</strong> {boat.color}
                </div>
                <div className="detail-item">
                  <strong>Engine:</strong> {boat.engine}
                </div>
                <div className="detail-item">
                  <strong>Hours:</strong> {boat.hours}
                </div>
                <div className="detail-item">
                  <strong>Delivery:</strong> {boat.deliveryTime}
                </div>
              </div>

              {/* Features */}
              <div className="boat-features">
                {boat.features.slice(0, 4).map((feature, idx) => (
                  <span key={idx} className="feature-tag">{feature}</span>
                ))}
                {boat.features.length > 4 && (
                  <span className="feature-tag more">+{boat.features.length - 4} more</span>
                )}
              </div>

              {/* Pricing */}
              <div className="boat-pricing">
                <div className="price-info">
                  <span className="msrp">MSRP: <s>{formatPrice(boat.msrp)}</s></span>
                  <span className="dealer-price">Dealer Price: {formatPrice(boat.price)}</span>
                </div>
                <div className="boat-actions">
                  <button className="inquire-button" onClick={() => setSelectedBoat(boat)}>
                    View Details
                  </button>
                  {boat.buildSheetURL && (
                    <button 
                      className="build-sheet-btn"
                      onClick={() => window.open(boat.buildSheetURL, '_blank')}
                      title="View Build Sheet"
                    >
                      <FileText size={16} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Factory Contact */}
      <div className="factory-contact">
        <h2>Ready to Order?</h2>
        <p>Contact our factory sales team for dealer pricing and availability</p>
        <div className="contact-buttons">
          <button className="primary-button">
            <Phone size={16} />
            Call Factory Sales: 1-888-CENTURION
          </button>
          <button className="secondary-button">
            <Mail size={16} />
            Email: dealer@centurionboats.com
          </button>
        </div>
      </div>

      {/* Boat Detail Modal */}
      {selectedBoat && (
        <BoatModal
          boat={selectedBoat}
          onClose={() => setSelectedBoat(null)}
        />
      )}
    </div>
  );
};

export default FactoryBoatsPage;